import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { COLOR_CODES_FABRIC } from 'commons/constants';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import useKeyboardControlForTabs from 'hooks/useKeyboardControlForTabs';
import VisuallyHidden from 'components/consumer/VisuallyHidden';

// Converts COLOR_CODES_FABRIC into a flat object, mapping color codes to names
const colorCodesMap = COLOR_CODES_FABRIC.reduce((acc, item) => ({
  ...acc,
  ...item
}), {});
const ColorsFilter = t0 => {
  const $ = _c(7);
  const {
    bindParentName: t1,
    colors: t2,
    disabledColors: t3,
    loading,
    onSelectColor,
    selectedColors,
    showAsTwoRows: t4,
    variant,
    showRowInMobile: t5,
    showMobileColorFilter: t6
  } = t0;
  const bindParentName = t1 === undefined ? false : t1;
  const colors = t2 === undefined ? [] : t2;
  const disabledColors = t3 === undefined ? {} : t3;
  const showAsTwoRows = t4 === undefined ? false : t4;
  const showRowInMobile = t5 === undefined ? false : t5;
  const showMobileColorFilter = t6 === undefined ? false : t6;
  const buttonsWrapperRef = useRef(null);
  useKeyboardControlForTabs(buttonsWrapperRef);
  const styles = {
    colorFabricItem: "bg-transparent rounded-[50%] border border-gray-light6 cursor-pointer block flex-1 h-5 list-none mr-1 min-w-[20px] focus-visible:outline-offset-[3px]",
    colorFabricItemActive: "outline-0 border-white shadow-[0_0_0_1px_#016a78]",
    fabricColorWhite: "shadow-[inset_0_0_0_1px_#e5e5e5]"
  };
  const cx = classNames.bind(styles);
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <VisuallyHidden>Clicking on the following button will update the content below.</VisuallyHidden>;
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  const t8 = showRowInMobile === false;
  let t9;
  if ($[1] !== showRowInMobile || $[2] !== t8) {
    t9 = classNames({
      "md:hidden": t8,
      hidden: showRowInMobile
    });
    $[1] = showRowInMobile;
    $[2] = t8;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const t10 = cx("flex flex-wrap w-full overflow-auto py-2 px-1 m-0 list-none", {
    "grid grid-cols-[repeat(6,_1fr)] py-1 px-0.5": !!showAsTwoRows,
    "max-[767px]:hidden": !showRowInMobile,
    "pl-9 overflow-x-scroll !flex-nowrap": showRowInMobile
  });
  const t11 = colors.map(color_1 => {
    const lColor_0 = color_1 && color_1.toLowerCase();
    const backgroundColor_0 = colorCodesMap[lColor_0] || "";
    const isDisabled = !!disabledColors[lColor_0];
    return <li className="flex list-none p-0 m-0 group" key={lColor_0}><button type="button" key={color_1} onClick={!isDisabled ? () => onSelectColor(color_1) : undefined} style={{
        backgroundColor: backgroundColor_0
      }} className={cx("colorFabricItem", {
        colorFabricItemActive: !!selectedColors[color_1],
        "opacity-[0.1] cursor-not-allowed": isDisabled,
        "max-[767px]:!w-10 max-[767px]:!h-10": showMobileColorFilter
      })} aria-label={color_1}>{loading && <span className="w-full h-full rounded-[50%] inline-block" />}{!!selectedColors[color_1] && <VisuallyHidden>- selected</VisuallyHidden>}</button></li>;
  });
  let t12;
  if ($[4] !== t10 || $[5] !== t11) {
    t12 = <ul className={t10}>{t11}</ul>;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  return <div className="ColorsFilter__wrapper" data-xc="ColorsFilter" ref={buttonsWrapperRef}>{t7}<div className={t9}><TogglePillGroup items={colors.filter(_temp).map(color_0 => {
        const lColor = color_0 && color_0.toLowerCase();
        const backgroundColor = colorCodesMap[lColor] || "";
        return {
          ariaLabel: color_0,
          label: <span className="items-center flex flex-row" key={lColor}><span style={{
              backgroundColor
            }} className={cx("colorFabricItem", "h-[21px] -my-[3px] -ml-[7px] min-w-[21px]", {
              "max-[767px]:!w-10 max-[767px]:!h-10": showMobileColorFilter,
              colorFabricItemActive: !!selectedColors?.[color_0]
            })} /><span className="-mr-0.5 relative -top-px leading-[0] capitalize">{color_0}</span></span>,
          id: color_0,
          isDisabled: disabledColors[color_0],
          isSelected: !!selectedColors[color_0],
          onClick: () => bindParentName ? onSelectColor("color", color_0) : onSelectColor(color_0)
        };
      })} variant={variant} /></div>{t12}</div>;
};
ColorsFilter.propTypes = {
  bindParentName: PropTypes.bool,
  colors: PropTypes.arrayOf(PropTypes.string),
  disabledColors: PropTypes.object,
  loading: PropTypes.bool,
  onSelectColor: PropTypes.func,
  selectedColors: PropTypes.object,
  showAsTwoRows: PropTypes.bool,
  variant: PropTypes.oneOf(['ShopByHeaderSection']),
  showRowInMobile: PropTypes.bool,
  showMobileColorFilter: PropTypes.bool
};
export default ColorsFilter;
function _temp(color) {
  return !!color;
}